export const faceSwapeStyleOptions = {
    style: {
      shotType: {
        label: '拍攝類型',
        options: {
          portrait: '肖像',
          headPortrait: '頭像',
          headAndShoulders: '頭肩像',
          halfLength: '半身像',
          fullLength: '全身像',
          face: '臉部',
          closeUp: '特寫'
        }
      },
      imagingStyle: {
        label: '成像風格',
        options: {
          standard: '標準模式',
          highContrast: '高對比度模式',
          landscape: '風景模式',
          portrait: '人像模式',
          blackAndWhite: '黑白模式',
          clarityEnhancement: '清晰度增強'
        }
      },
      artisticStyle: {
        label: '藝術風格',
        options: {
          realistic: '寫實風格',
          illustration: '插畫風格',
          cartoon: '卡通風格',
          watercolor: '水彩風格',
          vintage: '復古風格',
          steampunk: '蒸汽朋克風格'
        }
      },
      artEffect: {
        label: '藝術效果',
        options: {
          oilPainting: '油畫效果',
          inkWash: '水墨畫效果',
          sketch: '素描效果',
          coloredPencil: '彩色鉛筆效果'
        }
      },
      depthOfField: {
        label: '景深',
        options: {
          shallow: '淺景深',
          medium: '中景深',
          deep: '深景深'
        }
      },
      photoEffect: {
        label: '照片效果',
        options: {
          aspectRatioCrop: '長寬比裁剪 (1:1, 16:9)',
          vintage: '復古風格',
          hdr: 'HDR (高動態範圍)',
          filmEffect: '膠片效果',
          hardSoftLight: '硬光和柔光',
          longExposure: '長曝光效果'
        }
      },
      specialEffect: {
        label: '特殊效果',
        options: {
          lowSaturation: '低飽和度',
          highContrast: '高對比度',
          hdr: '高動態範圍 (HDR)',
          duotone: '雙色調效果',
          fluorescent: '螢光/霓虹風格'
        }
      },
      postProcessingStyle: {
        label: '後期處理風格',
        options: {
          filter: '濾鏡 (復古、黑白、膠片)',
          sharpening: '銳化',
          denoise: '降噪',
          colorCorrection: '色彩校正',
          filmGrain: '膠片顆粒'
        }
      }
    }
  };
